import { useEffect, useState } from "react";
import capitalize from "lodash/capitalize";
import { useRouter } from "next/router";
import { useDispatch } from "react-redux";

import { AUTH_API_URL } from "../config/constants";
import { isSSR } from "../helpers/ssr";
import useMemory from "./useMemory";
import { THROW_TOAST } from "../reducers/toasts";

const useProvidersSuccess = () => {
  const [requestSend, setRequestSend] = useState(false);
  const [redirectTo, setRedirectTo] = useState(null);

  const router = useRouter();
  const memory = useMemory();
  const dispatch = useDispatch();

  let timerId = null;

  useEffect(() => {
    if (!isSSR()) {
      if (router.query["error_description"]) {
        const errorTrigger =
          router.query["error_description"]?.match(/\[(.*?)\]/)?.[1] ||
          "required permission";

        const provider = capitalize(memory.get("last_provider", "social"));
        let message;
        if (errorTrigger) {
          message = `Sorry, looks like your ${provider} 
          account doesn't have ${errorTrigger}. It is required for authentication in "Real America's Voice". 
          You cannot connect ${provider} account without ${errorTrigger}.`;
        } else {
          message = `Sorry, looks like your ${provider} account doesn't have any permission  required for authentication in "Real America's Voice"`;
        }

        const data = { type: "error", message };

        dispatch({ type: THROW_TOAST, data });
        memory.set("toast", JSON.stringify(data));
        setRedirectTo(memory.get("last_page", window.location.origin));
      }
      if (!requestSend && router.query["code"]) {
        getTokenByCode(router.query["code"]);
      }
    }

    return () => {
      clearTimeout(timerId);
    };
  }, [router, requestSend]);

  const getTokenByCode = (code) => {
    setRequestSend(true);
    const params = {
      redirect_uri: `${window.location.origin}/providers/success/`,
      code,
    };

    fetch(`${AUTH_API_URL}/user/providers`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(params),
    })
      .then((res) => {
        if (res.status !== 200) {
          return res.json().then((err) => {
            throw err;
          });
        }
        setRedirectTo(memory.get("last_page", window.location.origin));
      })
      .catch((err) => {
        dispatch({
          type: THROW_TOAST,
          data: { type: "error", message: err.message },
        });
        memory.set(
          "toast",
          JSON.stringify({ type: "error", message: err.message })
        );

        timerId = setTimeout(() => {
          setRedirectTo(memory.get("last_page", window.location.origin));
        }, 3000);
      });
  };

  return { redirectTo };
};

export default useProvidersSuccess;
